(() => {
class HomepageProductRanking extends HTMLElement {
  constructor() {
    super();
    this.tabs = [];
    this.panels = [];
    this.prevButton = null;
    this.nextButton = null;
    this.lists = [];
    this.updateControlsFrame = null;
    this.prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
    this.handleTabClick = this.handleTabClick.bind(this);
    this.handlePrevClick = this.handlePrevClick.bind(this);
    this.handleNextClick = this.handleNextClick.bind(this);
    this.handleListScroll = this.handleListScroll.bind(this);
  }

  connectedCallback() {
    this.tabs = Array.from(this.querySelectorAll('[data-ranking-tab]'));
    this.panels = Array.from(this.querySelectorAll('[data-ranking-panel]'));
    this.prevButton = this.querySelector('.homepage-product-ranking__nav--prev');
    this.nextButton = this.querySelector('.homepage-product-ranking__nav--next');
    this.lists = Array.from(this.querySelectorAll('[data-ranking-list]'));

    this.tabs.forEach((tab) => tab.addEventListener('click', this.handleTabClick));
    this.lists.forEach((list) => list.addEventListener('scroll', this.handleListScroll, { passive: true }));
    this.prevButton?.addEventListener('click', this.handlePrevClick);
    this.nextButton?.addEventListener('click', this.handleNextClick);

    const activeTab = this.tabs.find((tab) => tab.classList.contains('is-active')) || this.tabs[0];
    if (activeTab) {
      this.activateTab(activeTab.dataset.rankingTab);
    } else {
      this.updateControls();
    }

    this.updateControlsFrame = window.requestAnimationFrame(() => this.updateControls());
  }

  disconnectedCallback() {
    this.tabs.forEach((tab) => tab.removeEventListener('click', this.handleTabClick));
    this.lists.forEach((list) => list.removeEventListener('scroll', this.handleListScroll));
    this.prevButton?.removeEventListener('click', this.handlePrevClick);
    this.nextButton?.removeEventListener('click', this.handleNextClick);
    window.cancelAnimationFrame(this.updateControlsFrame);
  }

  handleTabClick(event) {
    this.activateTab(event.currentTarget.dataset.rankingTab);
  }

  handlePrevClick() {
    this.scrollActiveList(-1);
  }

  handleNextClick() {
    this.scrollActiveList(1);
  }

  handleListScroll() {
    this.updateControls();
  }

  activateTab(tabKey) {
    this.tabs.forEach((tab) => {
      const isActive = tab.dataset.rankingTab === tabKey;
      tab.classList.toggle('is-active', isActive);
      tab.setAttribute('aria-selected', isActive ? 'true' : 'false');
    });

    this.panels.forEach((panel) => {
      panel.hidden = panel.dataset.rankingPanel !== tabKey;
    });

    this.updateControls();
  }

  scrollActiveList(direction) {
    const activePanel = this.panels.find((panel) => !panel.hidden);
    const list = activePanel?.querySelector('[data-ranking-list]');
    const firstItem = list?.querySelector('.homepage-product-ranking__item');

    if (!list || !firstItem) {
      return;
    }

    const listStyles = window.getComputedStyle(list);
    const gap = Number.parseFloat(listStyles.columnGap || listStyles.gap || '0');
    const distance = firstItem.getBoundingClientRect().width + gap;
    list.scrollBy({
      left: direction * distance,
      behavior: this.prefersReducedMotion.matches ? 'auto' : 'smooth',
    });
  }

  updateControls() {
    const activePanel = this.panels.find((panel) => !panel.hidden);
    const list = activePanel?.querySelector('[data-ranking-list]');

    if (!list || !this.prevButton || !this.nextButton) {
      return;
    }

    const maxScroll = list.scrollWidth - list.clientWidth;
    const currentScroll = list.scrollLeft;
    const hasOverflow = maxScroll > 1;

    this.prevButton.disabled = !hasOverflow || currentScroll <= 1;
    this.nextButton.disabled = !hasOverflow || currentScroll >= maxScroll - 1;
  }
}

if (!customElements.get('homepage-product-ranking')) {
  customElements.define('homepage-product-ranking', HomepageProductRanking);
}
})();
